import { hasAdminModuleAccess } from "./adminPermissions";

/** Module-aware home for staff (matches ProtectedRoute fallback order). */
export function resolveStaffHomeRoute(user) {
  const role = String(user?.role || "").toUpperCase();
  if (!["ADMIN", "SUPER_ADMIN", "ACCOUNTANT", "MARKETING"].includes(role)) {
    return null;
  }
  if (hasAdminModuleAccess(user, "DASHBOARD")) return "/dashboard/admin";
  if (hasAdminModuleAccess(user, "CONTROL")) return "/admin/control";
  if (hasAdminModuleAccess(user, "OPERATIONS")) return "/admin/operations";
  if (hasAdminModuleAccess(user, "PAYMENTS")) return "/admin/payments";
  if (hasAdminModuleAccess(user, "HISTORY")) return "/admin/history/deposits";
  return "/notifications";
}

export function getHomeRouteByRole(role, user = null) {
  if (!role) return "/login";
  if (role === "INVESTOR" || role === "MEMBER") return "/dashboard/investor";
  if (role === "ASSET_MANAGER") return "/dashboard/asset-manager";
  if (["ADMIN", "SUPER_ADMIN", "ACCOUNTANT", "MARKETING"].includes(role)) {
    if (user) {
      const staffHome = resolveStaffHomeRoute(user);
      if (staffHome) return staffHome;
    }
    return "/dashboard/admin";
  }
  return "/login";
}

export function hasAdminControlAccess(user) {
  return (
    hasAdminModuleAccess(user, "CONTROL")
    || hasAdminModuleAccess(user, "OPERATIONS")
    || hasAdminModuleAccess(user, "PAYMENTS")
  );
}
